import { Outlet } from "react-router"
import { FeatureFlag, ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function VisaBookingsLayout() {
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.VIEW_VISA_SERVICES}
		>
			<FeatureFlag flag="visa" show404>
				<Outlet />
			</FeatureFlag>
		</ForbidUnlessAuthorized>
	)
}
